export default __webpack_public_path__ + "static/media/IMG_174.dd498e83.jpg";